import MillesimaLink from '@/components/common/MillesimaLink';
import { TopCateg } from '@/models';
import { useAppSelector } from '@/redux';
import { formatUrl, getHrefForCategLink } from '@/utils/linkUtils';
import styles from './TopCategory.module.scss';

type TopCategoryProps = {
	t: (key: string, args?: any) => string;
	topCategory: TopCateg[];
	numberOfLinks?: number;
	isMobileDevice?: boolean;
	customClassName?: { title?: string; list?: string };
};

export const TopCategory = ({ t, topCategory, numberOfLinks = 5, isMobileDevice = false, customClassName }: TopCategoryProps) => {
	const { storeConf } = useAppSelector(({ root }) => root);

	const titleClassName = [styles.title, isMobileDevice && styles.mobile, customClassName?.title && customClassName.title]
		.filter(Boolean)
		.join(' ');

	const listClassName = [styles.list, isMobileDevice && styles.mobile, customClassName?.list && customClassName.list]
		.filter(Boolean)
		.join(' ');

	return (
		<>
			<div data-test-id="title" className={titleClassName}>
				{t('category:topCategory')}
			</div>
			<ul className={listClassName}>
				{topCategory.slice(0, numberOfLinks).map((link, index) => (
					<li key={index} data-test-id="list-item" data-rbf="list-item">
						<MillesimaLink
							type={isMobileDevice ? 'link' : 'inline-link'}
							href={getHrefForCategLink(link.url, link.id, link.isSpirit)}
							as={formatUrl(link.url, link.isSpirit, storeConf)}
							ariaLabel={link.name}
							innerHtml={link.name}
						/>
					</li>
				))}
			</ul>
		</>
	);
};

export default TopCategory;
